import _ from 'lodash'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import Carrier from '@/modules/shipping/model/Carrier'

/**
 * Tipos de reglas para el calculo de portes
 */
export enum CalculationRule {
    ByWeight = 'byWeight', ByAmount = 'byAmount',
}

/**
 * Tarifa de envío
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Rate {
    public id = 0
    public name = ''
    public createdAt = 0
    public updatedAt = 0
    public carrier = new Carrier('')
    public freeShippingFrom = 0
    public calculationRule = CalculationRule.ByWeight

    public readonly tempId = _.uniqueId('shipping_rate_')

    public get calcByAmount (): boolean {
        return this.calculationRule === CalculationRule.ByAmount
    }

    public static deserialize (data: KeyValuePair): Rate {
        const rate = new Rate()

        if (_.has(data, 'id')) {
            rate.id = data.id
        }

        rate.name = data.name
        rate.createdAt = parseFloat(data.created_at)
        rate.updatedAt = parseFloat(data.updated_at)
        rate.carrier = Carrier.convert(data.carrier)
        rate.freeShippingFrom = data.free_shipping_from
        rate.calculationRule = data.calculation_rule

        return rate
    }

  public static serialize (rate: Rate): KeyValuePair {
        return {
            name: rate.name,
            carrier: rate.carrier.id,
            free_shipping_from: rate.freeShippingFrom,
            calculation_rule: rate.calculationRule,
        }
    }
}
